module.exports = __webpack_public_path__ + "static/media/modernTeaRoom.31b9f974.JPG";